<template>
    <div class="box">
        <div class="form">
            <van-field v-if="memo" label="处置结果" :value="memo.czjg " readonly />
            <van-field v-if="memo" label="退款金额" :value="memo.tkje | toThousands(true)" readonly />
            <van-field v-if="memo.tkfs" label="退款方式" :value="memo.tkfs" readonly />
            <van-field
                readonly
                v-if="memo"
                rows="2"
                autosize
                label="补充说明"
                type="textarea"
                show-word-limit
                :value="memo.bcsm"
            />
            <div class="no-bottom-border">
                <van-field label="相关凭证" readonly />
            </div>
            <div class="imglist">
                <img @click="preview(disposalDetails.attach, index)"
                :src="item" v-for="(item, index) in disposalDetails.attach" :key="index" alt="">
            </div>
            <van-field v-if="belongEnterprise" label="审核结果" :value="reviewDetail.auditResults" readonly />
            <van-field v-if="belongEnterprise" label="审核意见" :value="reviewDetail.memo" readonly />

        </div>
        <div class="form">
            <van-field label="处置机构" :value="disposalDetails.optMechanismName" readonly />
            <div class="my-field">
                <div class="label">处置人员</div>
                <div class="content">
                    <span>{{ disposalDetails.optName }}</span>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', disposalDetails.optContactTel, 6)" href="javascript:void(0)" />
                </div>
            </div>
                <!-- <van-field
                    readonly
                    center
                    clearable
                    label="处置人员"
                    :value="disposalDetails.optName"
                >
                <template #button>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', disposalDetails.optContactTel)" href="javascript:void(0)" />
                </template>
                </van-field> -->
            <van-field label="处置时间" :value="disposalDetails.time" readonly />
            <van-field v-if="belongEnterprise" label="审核机构" :value="reviewDetail.optMechanismName" readonly />
            <van-field
                readonly
                v-if="belongEnterprise"
                center
                clearable
                label="审核人员"
                :value="reviewDetail.optName"
            >
            <template #button>
                <a class="call-icon" @click="util.callConfirm('拨打该号码？', reviewDetail.optContactTel, 6)" href="javascript:void(0)" />
            </template>
            </van-field>
            <van-field v-if="belongEnterprise" label="审核时间" :value="reviewDetail.time" readonly />
        </div>
    </div>
</template>

<script>
    import util from '../../../../utils/common'
    import { ImagePreview } from 'vant'

    export default {
        data () {
            return {
                detail: {},
                disposalDetails: {}, // 处置详情
                dictType: {}, // 所有枚举
                memo: {},
                historyIndex: 0,
                reviewDetail: {}, // 跟审核有关的数据
                belongEnterprise: false // 判断退货单是否属于企业处置的
            }
        },
        created () {
            this.detail = this.$store.state.refund.detail
            // console.log(this.detail, 'detail')
            this.dictType = this.$store.state.refund.dictType
            console.log(this.dictType, 'dictType')
            this.setDetail()
        },
        methods: {
            preview (imglist, index) {
              window.history.pushState(null, null, "#");
              const that = this
                ImagePreview({
                    images: imglist,
                    startPosition: index,
                     onClose() {
                      console.log('window.location.href', window.location.href);
                      if (window.location.href.indexOf('feedbackDisposalResultsDetail') === -1) {
                        that.$router.back()
                      }
                    }
                })
            },
            setDetail () {
                // this.disposalDetails = this.detail.history.find(i => i.optText === '已反馈处置结果' || i.optText === '已审核处置结果')
                this.disposalDetails = JSON.parse(this.$route.query.item)
                console.log('disposalDetails', this.disposalDetails)
                this.disposalDetails.time = util.getStampInDate(this.disposalDetails.creatTime, '/')

                if (this.disposalDetails.attach) {
                    this.disposalDetails.attach = this.disposalDetails.attach.split(',')
                }

                this.historyIndex = this.$route.query.historyIndex
                console.log('this.detail', this.detail)
                console.log('historyIndex', this.historyIndex)
                // if (this.detail.history && this.historyIndex !== 0 && this.detail.history[this.historyIndex - 1].creatTime) {
                if (this.detail.history && this.historyIndex !== 0) {
                    this.reviewDetail = this.detail.history[this.historyIndex]
                    this.reviewDetail.time = util.getStampInDate(this.reviewDetail.creatTime, '/')
                    this.reviewDetail.auditResults = (this.reviewDetail.optType == 71 ? '不通过' : '通过')
                }

                console.log('审核的数据', this.reviewDetail)

                if (this.disposalDetails && this.disposalDetails.memoJson) {
                    this.memo = JSON.parse(this.disposalDetails.memoJson)
                    console.log('重新赋值了')
                } else {
                    // 取optType为69的history
                    for (let i = this.historyIndex; i < this.detail.history.length; i++) {
                        if (this.detail.history[i].optType === 69) {
                            this.memo = JSON.parse(this.detail.history[i].memoJson)
                            this.disposalDetails.attach = this.detail.history[i].attach.split(',')
                            console.log('循环里面', this.memo)
                            break
                        }
                    }
                }

                console.log('memo', this.memo)
                if (this.detail.detail && this.dictType.FEEDBACK_TYPE) {
                    this.detail.detail.disposalResult = this.dictType.FEEDBACK_TYPE.find(i => i.code === this.detail.detail.feedbackStatus).name
                }
                this.detail.detail.refundMethod = this.detail.detail.centerRefundType == '10' ? '监理中心垫付' : '企业直退'
                this.belongEnterprise = (this.detail.detail.belongCenterType === 2)
            }
        }
    }
</script>
<style lang="less" scoped>
     .box {
        padding: 16px 16px 0;
        background-color: #f8f9fc;
        min-height: 100vh;
        padding-bottom: 30px;
        /deep/.form {
            margin-bottom: 16px;
            border-radius: 4px;
            background: white;
             .van-field__label {
                width: 56px;
                margin-right: 16px;
            }
            .my-field {
                background-color: white;
                display: flex;
                align-items: center;
                padding: 10px 0;
                margin: 0 16px;
                border-bottom: 0.1px solid #ebedf0;
                .label {
                    color: #646566;
                    font-size: 14px;
                    width: 56px;
                    margin-right: 16px;
                }
                .content {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #323233;

                    .call-icon {
                        display: inline-block;
                        width: 25px;
                        height: 25px;
                        background-color: #e9f7f1;
                        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA/5JREFUSEutll1sFFUUx/9nZit1d4mRvkHACC8akyZCaJESbBPRsFttDLaJJoKBSHgCgtuWaAhXfah2iyViIEaM3zHY+KC7tUCElqiBjhATwkcIRh/kgYQQa7Lb2u7OHL0z95a7012BXc/DZu8kc37zP5+XUMmEsLBXMAgM+StN/q/RAkdhkwACNx5LxeqL1sPRaPTCWJv42wfXCJ0LlMqE8FqO9ywszvDnzNxGFh3J5WMbL3aJmVqhpUCloOXb3iVFcjMMNAIoAoiA+IDTvm/7/wdUsBWZrVGb7suCuU3BbAAeABsR6nLWp4c6v+q0h7qG3GrSeUuhCmVzNrWTGYMACgDqlFMJtABccRFffu5pMVmt0gCo1LWOivqpfP4SMz/oP5V1ecuCs0UvOMn0l9WqDBxqdSO9a7jonlJqwhGTIbRhWe84yf5XWkdFZKxNyPzelflA/bWrhnu2eZ53qIK6II82bXIS6U9rUqi/tmk4tRcehCoSmTNtOoefJc7FXxJCyHNV5ivUwJXZ1B5ivBEC+rkjwsF7Y/EdfhhrGAAlIW3Odm9m5g+NkAaFQnTDXlB84PTqwalaYMF0NKp05dHeR6jg/mK0Q6AONFFH9tIf29/6s6o4Gi+VTBoZ2sncpAN4jxphVe3ALzvJfYerLRbNnAVqR82Z7h0M3j870gDVDjgfnYk/PvasmKglrHMmzWOZ1xa5mJa9uMxQ6UPJQt94cuBV3bdlw3ubVVYS0jIqdTso3wTbwvrTyfTROaGVoNcFyU0zO0z0Pq2UQ/18xdn36yLXfx1l5hZDpYZfA2Ot88zA77NQA7Ymu/v++nnsfb/u7b/8SISgFfdh80iqkYs4CaAhDCWin7g+0uE80XdT93BQcPldRLwHTHmysPtMIv2JL8JQXnbj6y9vyvZsAnsfh0ZdUESgE/PsyPM/JPputI6K+FQud5CBF0t6mOi9xNnYTjm6tNLyVwyjN5sy3YcA3lZuXRHRVWYcBnEHGKsRVLQeifJ/BKAvGuzFW0YS26dldVcGqg3y5LFUbGLGOgJ4SeVQLmRpoYLyz9Kf9in7N4ASDTrt6V3/DTRUtnzTM79o89fMvM64BUjH2qlUZQ57XX96p7rkYfl4x8D5ygr1K0qpn6d87iNmPKeglSBmewb5JlxlorU/J9PXbw/USuWehqDvhvNvgrlbzVsZRh1a05d8JtVFAFy2yNpwpr3/smyTOwNqqCrvpmzvU8TufgYeClWweVEmsug4iLaMJ/qv6el050AF7RzqtOSNTV6SowXaCMYGD7wUwCIA96hC+Q2W9UEDTb07kjgwbU6luwOGoPIonf0xf9li1ysssQkxeFRwiS7IfPlD3hx3/77wDzb0+y46N1GhAAAAAElFTkSuQmCC);
                        background-repeat: no-repeat;
                        background-size: 60% 60%;
                        background-position: center;
                        border-radius: 50%;
                    }
                    span {
                        margin-right: 10px;
                    }
                }
            }
            .van-cell::after {
                border-bottom: 1px solid #ebedf0;
            }
            .no-bottom-border {
                .van-cell::after {
                    border-bottom: 0;
                }
            }
            .signImg {
                border-radius: 4px;
                background-color: white;
                padding: 0 16px 16px;
                width: 100%;
                height: 280px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #ebedf0;
                }
            }
            .imglist {
                display: flex;
                background-color: white;
                flex-wrap: wrap;
                padding: 0 16px 16px;

                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 15px;
                    border-radius: 4px;
                    margin-bottom: 15px;
                }
            }
            .call-icon {
                display: inline-block;
                width: 25px;
                height: 25px;
                background-color: #e9f7f1;
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA/5JREFUSEutll1sFFUUx/9nZit1d4mRvkHACC8akyZCaJESbBPRsFttDLaJJoKBSHgCgtuWaAhXfah2iyViIEaM3zHY+KC7tUCElqiBjhATwkcIRh/kgYQQa7Lb2u7OHL0z95a7012BXc/DZu8kc37zP5+XUMmEsLBXMAgM+StN/q/RAkdhkwACNx5LxeqL1sPRaPTCWJv42wfXCJ0LlMqE8FqO9ywszvDnzNxGFh3J5WMbL3aJmVqhpUCloOXb3iVFcjMMNAIoAoiA+IDTvm/7/wdUsBWZrVGb7suCuU3BbAAeABsR6nLWp4c6v+q0h7qG3GrSeUuhCmVzNrWTGYMACgDqlFMJtABccRFffu5pMVmt0gCo1LWOivqpfP4SMz/oP5V1ecuCs0UvOMn0l9WqDBxqdSO9a7jonlJqwhGTIbRhWe84yf5XWkdFZKxNyPzelflA/bWrhnu2eZ53qIK6II82bXIS6U9rUqi/tmk4tRcehCoSmTNtOoefJc7FXxJCyHNV5ivUwJXZ1B5ivBEC+rkjwsF7Y/EdfhhrGAAlIW3Odm9m5g+NkAaFQnTDXlB84PTqwalaYMF0NKp05dHeR6jg/mK0Q6AONFFH9tIf29/6s6o4Gi+VTBoZ2sncpAN4jxphVe3ALzvJfYerLRbNnAVqR82Z7h0M3j870gDVDjgfnYk/PvasmKglrHMmzWOZ1xa5mJa9uMxQ6UPJQt94cuBV3bdlw3ubVVYS0jIqdTso3wTbwvrTyfTROaGVoNcFyU0zO0z0Pq2UQ/18xdn36yLXfx1l5hZDpYZfA2Ot88zA77NQA7Ymu/v++nnsfb/u7b/8SISgFfdh80iqkYs4CaAhDCWin7g+0uE80XdT93BQcPldRLwHTHmysPtMIv2JL8JQXnbj6y9vyvZsAnsfh0ZdUESgE/PsyPM/JPputI6K+FQud5CBF0t6mOi9xNnYTjm6tNLyVwyjN5sy3YcA3lZuXRHRVWYcBnEHGKsRVLQeifJ/BKAvGuzFW0YS26dldVcGqg3y5LFUbGLGOgJ4SeVQLmRpoYLyz9Kf9in7N4ASDTrt6V3/DTRUtnzTM79o89fMvM64BUjH2qlUZQ57XX96p7rkYfl4x8D5ygr1K0qpn6d87iNmPKeglSBmewb5JlxlorU/J9PXbw/USuWehqDvhvNvgrlbzVsZRh1a05d8JtVFAFy2yNpwpr3/smyTOwNqqCrvpmzvU8TufgYeClWweVEmsug4iLaMJ/qv6el050AF7RzqtOSNTV6SowXaCMYGD7wUwCIA96hC+Q2W9UEDTb07kjgwbU6luwOGoPIonf0xf9li1ysssQkxeFRwiS7IfPlD3hx3/77wDzb0+y46N1GhAAAAAElFTkSuQmCC);
                background-repeat: no-repeat;
                background-size: 60% 60%;
                background-position: center;
                border-radius: 50%;
            }
        }
    }
</style>
